import * as React from 'react';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import PromptRegistrationIdentifierForm from './user/PromptRegistrationIdentifierForm';
import { connect } from 'react-redux';
import * as RegisterUserStore from "./user/registerUserStore";
import * as RegisterCompanyStore from "./company/registerCompanyStore";
import { RegistrationPromptModel } from './user/RegisterUserModels';
import { RouteComponentProps } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import NarrowInfoContainer from '../components/NarrowInfoContainer';


const styles = (theme: Theme) => ({
    paper: {
        maxWidth: "600px",
        marginLeft: "auto",
        marginRight: "auto"
    }
});

type RegisterUserViewProps = { userActions: typeof RegisterUserStore.actionCreators, companyActions: typeof RegisterCompanyStore.actionCreators } & RouteComponentProps<{ identifier: string }> & WithStyles<"paper">;

class RegisterUserView extends React.Component<RegisterUserViewProps> {
    constructor(props: RegisterUserViewProps) {
        super(props);

        this.handleSubmitRegister = this.handleSubmitRegister.bind(this);
    }

    public render() {

        const { classes } = this.props;

        return <NarrowInfoContainer>
            <PromptRegistrationIdentifierForm onSubmit={this.handleSubmitRegister} onRegisterCompany={this.props.companyActions.registerCompany} />
        </NarrowInfoContainer>;
    }

    private handleSubmitRegister(data: RegistrationPromptModel) {
        this.props.userActions.registerUserRequest(data.identifier);
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        userActions: bindActionCreators(RegisterUserStore.actionCreators, dispatch),
        companyActions: bindActionCreators(RegisterCompanyStore.actionCreators, dispatch)
    }
}

export default withStyles(styles)(connect<any, any, any>(null, mapDispatchToProps)(RegisterUserView))


// WEBPACK FOOTER //
// ./src/register/RegisterUserView.tsx